module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "home"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "aboutContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "product"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "systemSoft"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "partnersList"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "outlines"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "renovation"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "partnerDetail"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "newsList"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "newsDetail"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "contactUs"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "jobContent"
    }
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "footer"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearFloat"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0010e2bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 20
// module chunks = 0